'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var countries = require('./countries.js');
var languages = require('./languages.js');
var graphql = require('./graphql.js');
var client = require('@apollo/client');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const LocaleContext = /*#__PURE__*/React__default["default"].createContext({
  locale: {
    language: undefined,
    country: undefined
  },
  loading: false
});
const isValidCountry = x => !!x && countries["default"].includes(x);
const isValidLanguage = x => !!x && languages["default"].includes(x);
const LocaleProvider = _ref => {
  let {
    value,
    children
  } = _ref;
  const {
    parameters: {
      retailerMoniker,
      language: initialLanguage,
      country: initialCountry
    },
    handleError
  } = value;
  let language = isValidLanguage(initialLanguage) ? initialLanguage : undefined;
  let country = isValidCountry(initialCountry) ? initialCountry : undefined;
  const {
    data,
    loading
  } = client.useQuery(graphql["default"], {
    variables: {
      retailerMoniker
    },
    skip: !!language
  });
  const {
    defaultLanguage = 'en',
    defaultCountry = 'US'
  } = (data === null || data === void 0 ? void 0 : data.globalSettings) || {};
  if (loading) {
    // locale is being determined. Set country and language to undefined
    language = undefined;
    country = undefined;
  } else if (!language) {
    handleError(`Invalid locale in request, retailer: ${retailerMoniker}, language: ${initialLanguage ?? 'undefined'}, country: ${initialCountry ?? 'undefined'}. Set locale to defaultLanguage: ${defaultLanguage ?? ''}, defaultCountry: ${defaultCountry ?? ''} instead.`);
    language = defaultLanguage;
    if (!country) {
      country = defaultCountry;
    }
  } else if (!country) {
    handleError(`Invalid localeCountry in request, retailer: ${retailerMoniker}, country: ${initialCountry ?? 'undefined'}. Set locale to language : ${language} only.`);
    country = undefined;
  }
  return /*#__PURE__*/React__default["default"].createElement(LocaleContext.Provider, {
    value: {
      locale: {
        country,
        language
      },
      loading
    }
  }, children);
};
var index = (() => React.useContext(LocaleContext));

exports.LocaleContext = LocaleContext;
exports.LocaleProvider = LocaleProvider;
exports["default"] = index;
exports.isValidCountry = isValidCountry;
exports.isValidLanguage = isValidLanguage;
